import { useRef } from "react";
import { Icon } from "@simplybusiness/mobius";
import { sparkles } from "@simplybusiness/icons";
import { ChatbotPrompt } from "./ChatbotPrompt";
import { ScrollButton } from "./ScrollButton";
import { useScrollableList } from "./useScrollableList";
import type { InsuranceAdvisorAttributes } from "../../../contexts";
import "./ChatbotPrompts.css";

export type ChatbotPromptsProps = {
  chatbotPrompts: string[];
  advisorAttributes?: InsuranceAdvisorAttributes;
};

export const ChatbotPrompts = ({
  chatbotPrompts,
  advisorAttributes,
}: ChatbotPromptsProps) => {
  const scrollRef = useRef<HTMLDivElement>(null);
  const { atStart, atEnd, isScrollable, handleScrollClick } = useScrollableList(
    scrollRef,
    chatbotPrompts.length,
  );

  return (
    <div className="mobius-chatbot-prompts" aria-label="Chatbot prompts">
      <Icon
        className={!atStart ? "--is-hidden" : ""}
        icon={sparkles}
        size="md"
        data-testid="sparkles-icon"
        title={atStart ? "AI-powered chatbot prompts" : undefined}
        aria-hidden={!atStart}
      />
      {isScrollable && (
        <ScrollButton
          onClick={handleScrollClick}
          isHidden={atStart}
          direction="left"
        />
      )}
      <div
        ref={scrollRef}
        className="mobius-chatbot-prompts__scroll"
        role="list"
      >
        {chatbotPrompts.map(prompt => (
          <div key={prompt} role="listitem">
            <ChatbotPrompt
              label={prompt}
              advisorAttributes={advisorAttributes}
            />
          </div>
        ))}
      </div>
      {isScrollable && (
        <ScrollButton
          onClick={handleScrollClick}
          isHidden={atEnd}
          direction="right"
        />
      )}
    </div>
  );
};
